export default __webpack_public_path__ + "ab7a0892139a1729a0719251b555bbb8.jpg";